<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.91758 11.6246C10.6793 11.6197 11.1667 12.4341 10.8023 13.103L8.8904 16.6128C8.72532 16.9158 8.72816 17.2826 8.89791 17.583L10.1788 19.8502C10.3562 20.1642 10.6889 20.3583 11.0495 20.3583H13.8828C14.2492 20.3583 14.5862 20.158 14.7613 19.8361L16.1136 17.3498C16.2827 17.0391 16.6033 16.8408 16.9568 16.8283L18.7048 16.7665C19.4782 16.7392 19.9882 17.5631 19.6188 18.2432L16.8782 23.2885C16.7075 23.6027 16.382 23.8019 16.0245 23.8108L9.09292 23.9846C8.71541 23.994 8.36477 23.79 8.18642 23.4572L5.12007 17.7343C4.96014 17.4358 4.96213 17.0767 5.12536 16.78L7.6717 12.1516C7.84634 11.8342 8.17902 11.636 8.54131 11.6337L9.91758 11.6246ZM3.6187 1.54284C3.79002 1.20954 4.13332 1 4.50808 1H10.6096C10.9762 1 11.3135 1.20064 11.4884 1.52286L14.004 6.15617C14.1646 6.45204 14.1656 6.8089 14.0066 7.10565L13.3041 8.4165C12.9289 9.11659 11.9266 9.12094 11.5454 8.42414L9.7277 5.10179C9.55227 4.78116 9.2159 4.58177 8.85042 4.58177H6.47496C6.10567 4.58177 5.76644 4.7853 5.59263 5.11113L4.12851 7.85599C3.97025 8.15268 3.9717 8.50904 4.13237 8.80443L5.53383 11.381C5.69057 11.6692 5.69601 12.0159 5.54838 12.3089L4.71206 13.9684C4.34887 14.6891 3.32556 14.7048 2.94033 13.9957L0.252284 9.04724C0.0944396 8.75667 0.090449 8.40685 0.241623 8.11275L3.6187 1.54284ZM20.181 1.0009C20.5399 1.00034 20.8715 1.19212 21.0501 1.50342L24.7209 7.90441C24.8942 8.20673 24.8977 8.57751 24.73 8.88303L21.603 14.5806C21.4273 14.9006 21.0913 15.0995 20.7263 15.0995H15.8056C15.4417 15.0995 15.1066 14.9019 14.9305 14.5835L14.1617 13.1934C13.793 12.5269 14.2751 11.7094 15.0367 11.7094H18.7132C19.0851 11.7094 19.4263 11.5029 19.599 11.1735L20.808 8.86595C20.9634 8.56937 20.9601 8.21471 20.7991 7.92111L19.3188 5.22084C19.1432 4.90062 18.8071 4.70156 18.4419 4.70156H15.7894C15.4342 4.70156 15.1057 4.51317 14.9263 4.20663L13.936 2.51433C13.5462 1.84828 14.0258 1.01047 14.7975 1.00927L20.181 1.0009Z" 
                :fill="color"
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgAMSNHome',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>